<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectId">
                 <!-- :disabled="model==='view'||model==='edit'" -->
              <el-select
              disabled
                v-model="form.projectId"
                style="width: 100%"
                placeholder="请选择项目名称"
                @change="projectIdChange"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"

                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属服务商" prop="providerId">
              <el-select
                 :disabled="model==='view'||model==='edit'"
                v-model="form.providerId"
                style="width: 100%"
                placeholder="请选择所属服务商"
                @change="providerIdChange"
              >
                <el-option
                  v-for="item in providerIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
 
          <el-col v-if="model!=='view'" :span="12">
            <el-form-item label="人员类型" prop="customerType">
              <el-select
                 :disabled="model==='view'||model==='edit'" 
                v-model="form.customerType"
                style="width: 100%"
                placeholder="请选择人员类型"
                @change="customerTypeChange"
              >
                <el-option
                  v-for="item in customerTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="form.customerType==1">
            <el-form-item label="姓名" prop="realName">
              <el-input
                clearable
                 :disabled="model==='view'||model==='edit'" v-model="form.realName"
                placeholder="请输入姓名"
                maxlength="30"
              ></el-input>  
            </el-form-item>
          </el-col>
          
          <el-col :span="12" v-if="form.customerType==2">
            <el-form-item label="姓名" prop="realName">
                <choicePeople v-if="model==='add'" :disabled="model==='view'||model==='edit'" :option="choicePeopleOption" @getPeople='getPeople'/>
                
                <el-input
                v-if="model==='view'||model==='edit'" 
                  clearable
                  :disabled="model==='view'||model==='edit'" v-model="form.realName"
                  placeholder="请输入姓名"
                  maxlength="30"
                ></el-input>  
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="登录手机号" prop="phone">
              <el-input
                clearable
                 :disabled="model==='view'||model==='edit'||form.customerType==2" v-model="form.phone"
                placeholder="请输入登录手机号"
                maxlength="30"
              ></el-input>  
            </el-form-item>
          </el-col>
          
          <el-col :span="12" v-if="form.customerType==1">
            <el-form-item label="密码" prop="password_">
              <el-input
                clearable
                 :disabled="model==='view'||model==='edit'||form.customerType==2" v-model="form.password_"
                placeholder="请输入密码"
                maxlength="30"
              ></el-input>  
            </el-form-item>
          </el-col>


          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select
                :disabled="model==='view'||model==='edit'||form.customerType==2" v-model="form.sex"
                style="width: 100%"
                placeholder="请选择性别"
                @change="sexChange"
              >
                <el-option
                  v-for="item in sexList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="出生年月" prop="birthday">
              <el-date-picker 
              :disabled="model==='view'||model==='edit'||form.customerType==2"
                @change="birthdayChange"
                style="width: 100%;" 
                value-format="yyyy-MM-dd HH:mm:ss" 
                v-model="form.birthday" 
                type="date" 
                placeholder="请选择生日"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属部门" prop="deptId">
              <avue-input-tree
              v-if="model==='add'"
              :disabled="model==='view'||model==='edit'||form.customerType==2"
                v-model="form.deptId"
                placeholder="请选择 所属部门"
                style="width: 100%"
                :dic="deptData"
                :props="{
                  children: 'children',
                  label: 'title',
                }"
              ></avue-input-tree>
                <el-input
                v-if="model==='view'||model==='edit'" 
                  clearable
                  :disabled="model==='view'||model==='edit'" v-model="form.deptName"
                  placeholder="请输入姓名"
                  maxlength="30"
                ></el-input>
              
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所属角色" prop="roleId">
              <avue-input-tree
                v-if="model==='add'" 
              :disabled="model==='view'||model==='edit'||form.customerType==2" 
                v-model="form.roleId"
                placeholder="请选择 所属角色"
                style="width: 100%"
                :dic="roleData"
                :props="{
                  children: 'children',
                  label: 'title',
                }"
              ></avue-input-tree>
                <el-input
                v-if="model==='view'||model==='edit'" 
                  clearable
                  :disabled="model==='view'||model==='edit'" v-model="form.roleName"
                  placeholder="请输入姓名"
                  maxlength="30"
                ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="岗位级别" prop="roleType">
              <el-select
                :disabled="model==='view'" v-model="form.roleType"
                style="width: 100%"
                placeholder="请选择岗位级别"
                @change="roleTypeChange"
              >
                <el-option
                  v-for="item in roleTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item v-if="model!=='view'" label="身份证号" prop="certNo">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.certNo"
                placeholder="请输入身份证号"
                maxlength="30"
              ></el-input>  
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="住址" prop="address">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.address"
                placeholder="请输入住址"
                maxlength="30"
              ></el-input>  
            </el-form-item>
          </el-col>

        </el-row>


        <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="身份证件" prop="contactPictureUrlList">
                <vUpload 
                 :disabled="model==='view'" :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多3张'" :types="['jpg','png']"  :max="5242880" :limit="9" :fileList.sync="form.contactPictureUrlList"></vUpload>
              </el-form-item>
            </el-col>
        </el-row>


        
        <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="人员资质" prop="authPictureUrlList">
                <vUpload 
                 :disabled="model==='view'" :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多3张'" :types="['jpg','png']"  :max="5242880" :limit="9" :fileList.sync="form.authPictureUrlList"></vUpload>
              </el-form-item>
            </el-col>
        </el-row>
        
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  saveProviderInfo,
  updateProviderInfo,
  saveProviderUserInfo,
  updateProviderUserInfo,
  getMatetial,
  getNursinghome,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getNursingList,
  getDeviceTypeList,
  getDeviceModelList,
  saveWristband,
  getBasicInforDetail,
  updateWristband,
  getProviderList,
  getServiceProviderUserDetail,getDeptTreeApi
} from '../api/serveItemManage';
import {getRoleTree} from "@/api/v4ward/v4system/role";
import vUpload from "../components/mutil-upload.vue"
import md5 from 'js-md5';
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue'
    export default {
  components: {vUpload,choicePeople},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
    projectId:{
      default: '',
    },
  },
  data() {
    return {
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'singlePeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 1,
      },
      roleTypeList: [],
      provideList: [
      ],
      providerIdList: [],
      customerTypeList: [{
        name:'新用户',
        id:'1'
      },{
        name:'系统已有用户',
        id:'2'
      }],
      form: {
        projectId:'',
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode:"",
        authPictureUrlList:[],
        contactPictureUrlList:[],
        moduleTypesIds:[],
        moduleTypes:'',
        password_:'',
        password:'',
        id:'',
        certNo:'',
        address:'',
        deptId:'',
        roleId:'',
        realName:'',
      },
      formRules: {
        projectId: [{ required: true, message: '项目名称不能为空', trigger: 'change' }],
        providerId: [{ required: true, message: '所属服务商不能为空', trigger: 'change' }],
        customerType: [{ required: true, message: '人员类型不能为空', trigger: 'change' }],
        realName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        phone: [{ required: true, message: '登录手机号不能为空', trigger: 'change' }],
        password_: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
        deptId: [{ required: true, message: '所属部门不能为空', trigger: 'change' }],
        roleId: [{ required: true, message: '所属角色不能为空', trigger: 'change' }],
        roleType: [{ required: true, message: '岗位级别不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
      projectList:[],
      typeList:[],
      moduleTypeList:[],
      deptData:[],
      roleData:[],
      sexList:[{
        dictKey:'1',
        dictValue:'男'
      },{
        dictKey:'2',
        dictValue:'女'
      },{
        dictKey:'3',
        dictValue:'未知'
      }]
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    projectIdChange(id){
      this.choicePeopleOption.projectId = id;
      this.choicePeopleOption = this._.cloneDeep(this.choicePeopleOption);
    },
    customerTypeChange(id){
      this.form.userId = '';
      this.choicePeopleOption.selectList = [];
      this.form = this._.cloneDeep(this.form);
    },
      handlePeople(){
          let idArry = this.form.customerServiceUserIds.split(',')
          let nameArry = this.form.customerServiceUserNames.split(',')
          let length = idArry.length
          for(let i =0;i<length;i++){
              let obj ={
                   id:idArry[i],
                    realName:nameArry[i],
              }
              this.choicePeopleOption.selectList.push(obj)
          }
          this.projectIdChange(this.form.projectId);
      },
    //选人组件获取人员后赋值
    getPeople(obj){
        console.log("getPeople==========>",obj);
        // let arr = [];
        // obj.forEach((ele)=>{
        //     arr.push(ele.id);
        // });
        // this.form.userIdList = arr;
        // this.form.customerServiceUserIds = arr.join(',');
        // this.form.id = arr.join(',');
        this.form.userId = obj.id;
        this.form.certNo = obj.certNo
        this.form.address = obj.address
        this.form.phone = obj.phone
        this.form.deptId = obj.deptId
        this.form.deptName = obj.deptName
        this.form.roleId = obj.roleId
        this.form.roleName = obj.roleName
        this.form.sex = obj.sex
        this.form.birthday = obj.birthday
        this.form.realName = obj.realName
        
        
        // this.form.certNo = obj.certNo
        this.form = this._.cloneDeep(this.form);
        
        console.log("getPeople===========>",this.form);
    //   this.ruleForm.userIds = obj.id
    },
    userIdChange(val){
      let self = this;
      this.userList.forEach(ele=>{
        if(ele.id === val){
          self.form.tel = ele.tel;
          self.form.idNumber = ele.idNumber;
        }
      })
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          nursinghomeId: this.form.nursinghomeId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      
    getDeptTreeApi().then(({ data }) => {
      this.deptData = data;
    });
    getRoleTree().then(({ data }) => {
      console.log("getRoleTree============>",data);
      this.roleData = data.data;
    });
      console.log(this.form,this.model)
      getProjectList().then((res) => {
        this.projectList = res.data;
        this.form.projectId = this.projectId||res.data[0].id;
      this.choicePeopleOption.projectId = this.form.projectId;
          console.log('getBasicInforDetail======================>');
        getProviderList({projectId:this.row.projectId,status:1}).then((res) => {
          this.providerIdList = res.data;
        });
      });

      if(this.model === 'add'){
        this.formRules.deptId[0].required = true;
        this.formRules.roleId[0].required = true;
      }else{
        this.formRules.deptId[0].required = false;
        this.formRules.roleId[0].required = false;
        this.form = this._.cloneDeep(this.row);;
        getServiceProviderUserDetail({id:this.row.id}).then(res=>{
          let self = this;
          this.form = res.data;
          this.form.roleType = this.form.roleType+'';
          this.form.customerType = '2';
      this.choicePeopleOption.selectList = 
                   [{id:res.data.userId,
                    realName:res.data.realName}]
          // this.form.moduleTypesIds = this.form.moduleType.split(',');
          this.form.contactPictureUrlList = [];
          this.form.authPictureUrlList = [];
          this.form.attachList.forEach(ele=>{
            if(ele.moduleType == 616 ){
              this.form.contactPictureUrlList.push(ele);
            }
            if(ele.moduleType == 617 ){
              this.form.authPictureUrlList.push(ele);
            }
          })
          this.form = this._.cloneDeep(self.form);
          this.projectIdChange(res.data.projectId);
        });
        // this.form.moduleTypesIds = this.form.moduleTypes.split(',');
      }
      // getDictionary('nursinghome_device_category_type').then((res) => {
      //   this.deviceCategoryList = res.data;
      // });
      // getDictionary('nursinghome_payment_type').then((res) => {
      //   this.paymentTypeList = res.data;
      // });
      
      
      // getDictionary('out_order_service_provider_type').then((res) => {
      //   this.typeList = res.data;
      // });
      // getDictionary('out_order_module_type').then((res) => {
      //   this.moduleTypeList = res.data;
      // });
      getDictionary('out_order_service_provider_user_role_type').then((res) => {
        this.roleTypeList = res.data;
      });
      
      if (this.model === 'add') {
        // this.form.nursinghomeId = this.nursinghomeId;
        // await getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;

        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
        // if (this.form.consumableId != '') {
        //   this.consumableIdChange();
        // }
      } else {
      }
    },
    saveRecord() {
      if(this.form.moduleTypesIds&&this.form.moduleTypesIds.length>0){
        this.form.moduleTypes = this.form.moduleTypesIds.join(',');
      }
      this.form.attachList = [];
      if(this.form.contactPictureUrlList&&this.form.contactPictureUrlList.length>0){

        let arrPic = [];
        this.form.contactPictureUrlList.forEach((ele)=>{
          arrPic.push({id:ele.id,moduleType: 616});
        })
        this.form.attachList = arrPic;
        }
      if(this.form.authPictureUrlList&&this.form.authPictureUrlList.length>0){

        let arrPic = [];
        this.form.authPictureUrlList.forEach((ele)=>{
          arrPic.push({id:ele.id,moduleType: 617});
        })
        this.form.attachList = this.form.attachList.concat(arrPic);
        }
      if ((this.model === 'add')) {
        if(this.form.customerType == 1){
          this.form.password = md5(this.form.password_)
        }
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveProviderUserInfo(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      }else{
        
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateProviderUserInfo(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  